<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-information@3x.svg" alt="" />
    <span>Organisation's information</span>
  </ng-container>

  <div body>
    <div *ngIf="model.organization" class="box">
      <h4>{{ model.organization.companyName }}</h4>
      <div class="row">
        <div class="col-12 data-group">
          <app-data-point>
            <span label>Main address</span>
            <div value>{{ model.organization.mainAddress }}</div>
          </app-data-point>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Telephone number</span>
            <div value>{{ model.organization.telephoneNo }}</div>
          </app-data-point>
        </div>
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Fax number</span>
            <div value>{{ model.organization.faxNo }}</div>
          </app-data-point>
        </div>
      </div>
    </div>
    <div *ngIf="model.contactPerson" class="box">
      <div class="sub-header">Contact person information</div>
      <div class="row">
        <div class="col-12 data-group">
          <app-data-point>
            <span label>Name of organisation's representative</span>
            <div value>
              {{ model.contactPerson.organizationRepresentative }}
            </div>
          </app-data-point>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Email address</span>
            <div value>
              {{ model.contactPerson.emailAddress }}
            </div>
          </app-data-point>
        </div>
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Mobile number</span>
            <div value>
              {{ model.contactPerson.mobileNo }}
            </div>
          </app-data-point>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="row">
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Name of Treasury Advisor</span>
            <div value *ngIf="model.treasuryAdvisorName">
              {{ model.treasuryAdvisorName }}
            </div>
          </app-data-point>
        </div>
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Date of last FNA done</span>
            <div value *ngIf="model.lastFNADate">
              {{ model.lastFNADate  }}
            </div>
          </app-data-point>
        </div>
      </div>
    </div>

    <div class="bottom-nav">
      <app-back-button (click)="goToPreviousScreen()"></app-back-button>
      <app-next-button
        buttonType="submit"
        (click)="model.onSubmit()"
      ></app-next-button>
    </div>
  </div>
</app-screen-content>
